import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/generative-ai/generative_ai_subbanner.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud nlp_advance_solution generative-ai-subbanner"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="">
            <h2>
              Lead with <span>AI-Powered Innovation</span>
            </h2>
            <p>
              Accelerate digital transformation with TekRevol’s generative AI
              solutions, designed for seamless integration and exceptional
              results.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Transform with AI
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
